import React, { useState } from 'react';
import './css/FaqAccordion.css';

const faqData = [
  {
    question: "Who are we?",
    answer:
      "We are a passionate team of travel experts dedicated to providing unforgettable safari experiences across Africa. With years of experience and local partnerships, we ensure every journey is safe, authentic, and tailored to you.",
  },
  {
    question: "What makes our safaris unique?",
    answer:
      "Our safaris are fully customizable, eco-conscious, and led by experienced local guides. We prioritize ethical tourism and work closely with communities and conservation groups.",
  },
  {
    question: "Where are we based?",
    answer:
      "Our head office is located in Nairobi, Kenya but we operate throughout East and Southern Africa through trusted in-country partners.",
  },
  {
    question: "Do we offer customized safaris?",
    answer:
      "Yes! We specialize in tailor-made safaris designed around your travel dates, interests, and budget.",
  },
  {
    question: "How long have we been in business?",
    answer:
      "We’ve been creating exceptional safari experiences since 2018. Our team brings together over 7 years of combined experience.",
  },
  {
    question: "What values guide our company?",
    answer:
      "Integrity, sustainability, community support, and unforgettable guest experiences are at the heart of everything we do.",
  },
  {
    question: "How can I contact your team?",
    answer:
      "You can reach us via our contact form, email at info@joujosafaris.com, or call us at . We're here to help 7 days a week!",
  },
];

const FaqAccordion = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-container">
      {faqData.map((item, index) => (
        <div
          className={`faq-item ${openIndex === index ? 'open' : ''}`}
          key={index}
        >
          <div className="faq-question" onClick={() => toggle(index)}>
            <h4>{item.question}</h4>
            <div className={`arrow ${openIndex === index ? 'rotate' : ''}`}>
              ▼
            </div>
          </div>
          <div
            className="faq-answer"
            style={{
              maxHeight: openIndex === index ? '300px' : '0px',
            }}
          >
            <p>{item.answer}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FaqAccordion;
